/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PropertyBudgetAnalysis { 
    date: string;
    rental_income_budget: number;
    occupancy_budget: number;
    rental_income_actual: number;
    occupancy_actual: number;
}

